import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { schemaValidateCatalogPhasesList } from "../../app/data/schemaValidateCatalogPhasesList";
import useFormValidationsGeneric from "../../app/hooks/useFormValidationsGeneric";
import ViewLabel from "../generic-component/ViewLabel";
import NewInputGeneric from "../generic-component/NewInputGeneric";
import NewRelationGeneric from "../generic-component/NewRelationGeneric";
import NewTextGeneric from "../generic-component/NewTextGeneric";
import EditYearGeneric from "../generic-component/EditYearGeneric";
import NewDateGeneric from "../generic-component/NewDateGeneric";
import NewCatalogRelationGeneric from "../generic-component/NewCatalogRelationGeneric";
import NewCatalogLocationGeneric from "../generic-component/NewCatalogLocationGeneric";
import { catalogPhaseClean, catalogPhaseStartUpdate } from "../../app/actions/catalogPhaseActions";
import NavbarIconsCatalogPhases from "../generic-nav-bar/NavbarIconsCatalogPhases";

const ID_FORM = "admin-phase";
const OPERATION = "edit";

const EditCatalogPhases = () => {
  debugLogPages(':: EditCatalogPhases'); 

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { catalogPhase, listFullCatalogPhases } = useSelector((state) => state.catalogPhase);

    const { values, errors, handleChange, handleSubmit, handleChangeCatalogCiiu,
    handleChangeCatalogSection, handleChangeCatalogPhase, handleChangeLocation } = useFormValidationsGeneric(
      () => catalogPhaseCallback(),
      catalogPhase,
      schemaValidateCatalogPhasesList
    );

    useEffect(() => {
        
        if (values) {
          handleChange(getObjectById(values.parent_id, listFullCatalogPhases), "parent_id");
    
        }
    
      }, [listFullCatalogPhases])

      const getObjectById = (id, arraySearch) => {
        const elementFound = arraySearch.find((ser) => ser.id === id);
        return elementFound;
      };
    
         const getMethodData = (currentData) => {
          //console.log("getMethodData, currentData", currentData);
        let comboData = [];
        let level = 0;
    
        if (currentData === "parent_id") {
          comboData = listFullCatalogPhases;
          level = 1;
        } 
    
        return { comboData, level };
      };

  function catalogPhaseCallback() {
    debugLogPages(':: EditCatalogPhases, catalogPhaseCallback, values', {values}); 

    let valuesSubmit = { ...values };
    valuesSubmit.deleted = false;

    debugLogPages(':: EditCatalogPhases, catalogPhaseCallback, valuesSubmit', {valuesSubmit}); 
    dispatch(catalogPhaseStartUpdate(valuesSubmit, navigate));

    dispatch(catalogPhaseClean());
  }

    debugLogPages(':: EditCatalogPhases', {values}); 
    debugLogPages(':: EditCatalogPhases', {errors}); 

  return (
    <div>
      <NavbarIconsCatalogPhases page={"editCatalogPhases"} />
      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="section is-fullheight">
        <div className="container">
          <form onSubmit={handleSubmit} noValidate>

          {/* Formulario dinamico*/}

            <div className="row boxContent">
              {
                schemaValidateCatalogPhasesList && schemaValidateCatalogPhasesList.length > 0 && (
                  schemaValidateCatalogPhasesList.map((techSecondary, index) => {

                    let varField = techSecondary.field;
                    let varRelation = techSecondary.key_relation;
                    const { comboData, level } = getMethodData(techSecondary.field);

                    if (techSecondary.component_new === "ViewGroupLabel") {
                      return (
                        <ViewLabel
                          key={techSecondary.id}
                          values={values}
                          errors={errors}
                          values2={varRelation}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_view}
                        />
                      )
                    } if (techSecondary.component_new === "NewInputGeneric") {
                      return (
                        <NewInputGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewRelationGeneric") {
                      return (
                        <NewRelationGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                          comboData={comboData}
                        />
                      );
                    } else if (techSecondary.component_new === "NewTextGeneric") {
                      return (
                        <NewTextGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewYearGeneric") {

                      return (
                        <EditYearGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewDateGeneric") {
                      return (
                        <NewDateGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    }  else if (techSecondary.component_new === "NewCatalogRelationGeneric") {
                      return (
                        <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogCiiu}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}
                            comboData={comboData}
                            level={level}
                        />
                      );
                    } else if (techSecondary.component_new === "NewCatalogRelationGeneric1") {
                      if (techSecondary.comparable_relation_condition === "CatalogCiius") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogCiiu}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogSections") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogSection}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogPhases") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogPhase}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      }
                    } else if (techSecondary.component_new === "NewCatalogLocationGeneric") {
                      return (
                        <NewCatalogLocationGeneric
                          key={techSecondary.id}
                          handleChange={handleChangeLocation}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        
                        />
                      );
                    } else {
                      return (
                        <div>
                        </div>
                      )
                    }
                  })
                )
              }
            </div>

            {/* Fin Formulario dinamico */}

            <div className="btnGuardar">
              <input type="submit" value={t("buttons.submit")} className="btn btn-primary" />
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default EditCatalogPhases;
